import { useTranslation } from 'react-i18next';
import RttRoundedIcon from '@mui/icons-material/RttRounded';
import { useDispatch } from 'react-redux';

import { COLLAPSED_BUTTON_SIZES, COLLAPSED_BUTTON_TYPES } from '../../../components/collapsed-button/CollapsedButton';
import { navigateToStoryWithFavorite } from '../utils/fromFavoriteToStoryMedia';

const useAdditionalFavoriteCardActions = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('activ8');

  const handleOpenStoryFromFavorites = (favoriteItem) => {
    navigateToStoryWithFavorite(dispatch, favoriteItem);
  };

  return [
    {
      label: t('goToStory'),
      icon: RttRoundedIcon,
      type: COLLAPSED_BUTTON_TYPES.TABLE_ROW,
      size: COLLAPSED_BUTTON_SIZES.MEDIUM,
      onClick: handleOpenStoryFromFavorites,
    },
  ];
};

export default useAdditionalFavoriteCardActions;
